import './UnderHeaderLine.scss';

export default function UnderHeaderLine() {
    return (
        <div className="under-header-line" />
    );
}